<template>
  <div class="home">
    <main-parent v-if="userIsAParent"/>
    <div v-else>
      <main-child />
    </div>
  </div>
</template>
<script>
import mainParent from "@/components/main/mainParent.vue";
import mainChild from "@/components/main/mainChild.vue";
import { mapGetters } from "vuex";
import store from "@/store";
export default {
  components: {
    mainParent,
    mainChild
  },
  computed: {
    ...mapGetters("user", ["userIsAParent", "getUserId"])
  },
  beforeRouteEnter(to, from, next) {
    let userId = store.getters["user/getUserId"];
    let promiseEvents = [];

    if (store.getters["user/userIsAParent"]) {
      promiseEvents = [
        store.dispatch("badges/FetchParentLockedBadges", userId)
      ];
      
    } else {
      promiseEvents = [
        store.dispatch("badges/FetchChildLockedBadges", userId)
      ];
    }
    Promise.all(promiseEvents).then(() => {
      next();
    });
  }
};
</script>
